import { Chart, Plugin } from 'chart.js';

export const CHART_NARROW_ASPECT_SELECTOR = '[data-chart-narrow-aspect="on"]';
export const NARROW_CHART_MAX_WIDTH = 480;
export const NARROW_CHART_ASPECT_RATIO = 1.5;

const WIDE_ASPECT_RATIO_FLOOR = 2;

function useTallerRatioWhenNarrow(chart: Chart): void {
  const container = chart.canvas?.parentElement;
  if (!container || !chart.canvas.closest(CHART_NARROW_ASPECT_SELECTOR)) return;

  const ratio = chart.options.aspectRatio;
  const width = container.clientWidth;
  if (typeof ratio === 'number' && ratio > WIDE_ASPECT_RATIO_FLOOR && width > 0 && width < NARROW_CHART_MAX_WIDTH) {
    chart.options.aspectRatio = NARROW_CHART_ASPECT_RATIO;
  }
}

export const narrowChartAspectRatioPlugin: Plugin = {
  id: 'narrowChartAspectRatio',
  beforeInit(chart: Chart) {
    useTallerRatioWhenNarrow(chart);
  },
  beforeUpdate(chart: Chart) {
    useTallerRatioWhenNarrow(chart);
  },
};
